import { useRestHeaderStore } from 'scbk-services/http/stores/restHeaderStore.ts';
import _ from 'scbk-services/utils/lodash-extension.ts';

import type { RestContext } from 'scbk-services/types/http/rest-context';
import type { RestRequest } from 'scbk-services/types/http/rest-request';

const useRestContext = () => {
    const getRestRequestHeader = useRestHeaderStore((state) => state.getRestRequestHeader);
    const resetRestRequestHeader = useRestHeaderStore((state) => state.resetRestRequestHeader);
    const setRestRequestHeader = useRestHeaderStore((state) => state.setRestRequestHeader);
    const updateRestRequestHeader = useRestHeaderStore((state) => state.updateRestRequestHeader);

    const resetContext = (): void => {
        resetRestRequestHeader();
    };

    const resetDynamicContext = (): void => {
        const header: RestRequest.Header = {
            'x-auth-token': undefined,
        };

        updateRestRequestHeader(header);
    };

    const setContext = (context: RestContext.Context): void => {
        const header: RestRequest.Header = {
            'X-Market': context.country,

            //채널/단말정보
            country: context.country,
            channel: context.channel,
            'x-device-id': context.deviceId,
            'x-app-version': context.appVersion,
            'x-os-type': context.osType,
            'x-os-version': context.osVersion,
            'x-client-ip': context.clientIp,

            //요청 추적 및 화면(메뉴)정보
            'x-tracking-id': context.trackingId,
            'x-screen-id': context.screenId,
            'x-menu-id': context.menuId,

            //인증정보
            'x-auth-token': context.xAuthToken,
            Authorization: _.isNotEmpty(context.cslAccessToken)
                ? `Bearer ${context.cslAccessToken}`
                : undefined,

            //언어/로케일정보
            'Accept-Language': context.locale,
            language: context.locale,

            //IPINSDE 솔루션 정보
            'x-ipinside-ip': context.natip,
            'x-ipinside-ax': context.wdata,
            'x-ipinside-mac': context.mac,
            'x-ipinside-hdd': context.mduinfo,

            //[2026.03.31] 최성돈
            'x-uuid': context.uuid,
            'x-sim-serial': context.simSerial,

            //[2026.04.22] 최성돈
            'x-ac-type': context.acType ?? '',
            'x-force-check-code': context.forceCheckCode,
        };

        const omittedHeader = _.omitBy(header, _.isUndefined);

        console.log('useRestContext > setContext - omittedHeader', omittedHeader);

        setRestRequestHeader(omittedHeader);
    };

    const updateContext = (context: RestContext.Context): void => {
        const header: RestRequest.Header = {
            'X-Market': context.country,

            //채널/단말정보
            country: context.country,
            channel: context.channel,
            'x-device-id': context.deviceId,
            'x-app-version': context.appVersion,
            'x-os-type': context.osType,
            'x-os-version': context.osVersion,
            'x-client-ip': context.clientIp,

            //요청 추적 및 화면(메뉴)정보
            'x-tracking-id': context.trackingId,
            'x-screen-id': context.screenId,
            'x-menu-id': context.menuId,

            //인증정보
            'x-auth-token': context.xAuthToken,
            Authorization: _.isNotEmpty(context.cslAccessToken)
                ? `Bearer ${context.cslAccessToken}`
                : undefined,

            //언어/로케일정보
            'Accept-Language': context.locale,
            language: context.locale,

            //IPINSDE 솔루션 정보
            'x-ipinside-ip': context.natip,
            'x-ipinside-ax': context.wdata,
            'x-ipinside-mac': context.mac,
            'x-ipinside-hdd': context.mduinfo,

            //[2026.03.31] 최성돈
            'x-uuid': context.uuid,
            'x-sim-serial': context.simSerial,

            //[2026.04.22] 최성돈
            'x-ac-type': context.acType ?? '',
            'x-force-check-code': context.forceCheckCode,
        };

        const omittedHeader = _.omitBy(header, _.isUndefined);

        console.log('useRestContext > updateContext - omittedHeader', omittedHeader);

        updateRestRequestHeader(omittedHeader);
    };

    return {
        getRestRequestHeader,
        resetContext,
        resetDynamicContext,
        setContext,
        updateContext,
    };
};

export default useRestContext;
